var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-onboarding-domain flex-column" },
    [
      _vm._t("default", [
        _c("div", { staticClass: "typographies-heading-h2" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$l10n.__("Paramètres de configuration")) +
              "\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-column", staticStyle: { gap: "8px" } }, [
        _c(
          "div",
          {
            staticClass:
              "typographies-paragraph-medium-regular information-text"
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$l10n.__(
                    "La sécurité des emails est essentielle, un domaine mal configuré peut entrainer un problème de réception de vos emails. C’est pourquoi, nous vous conseillons fortement d’authentifier votre domaine auprès de votre hébergeur afin d’améliorer la délivrabilité de vos futurs emails."
                  )
                ) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "typographies-paragraph-medium-semibold email-onboarding-domain__caption"
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$l10n.__(
                    "Besoin d’aide ? Consultez notre tutoriel dédié : "
                  )
                ) +
                "\n            "
            ),
            _c("CompassLink", {
              attrs: {
                label: _vm.$t.__(
                  "email.EmailOnboardingDomain.help_domain_authentication"
                ),
                link:
                  "https://help.sellsy.com/hc/receiving-and-sending-emails-with-sellsy/set-up-your-domain-for-better-deliverability?searched=true",
                target: "blank"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex-row gray-0-bkg p-3 ai-center jc-space email-onboarding-domain__validate-domain"
        },
        [
          _c("div", { staticClass: "typographies-paragraph-medium-semibold" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$l10n.__("Votre nom de domaine à authentifier")) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("CompassInput", { attrs: { disabled: true, value: _vm.domain } })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "typographies-heading-h3" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Configuration requise")))
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "email-onboarding-domain__caption typographies-paragraph-medium-regular"
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$l10n.__(
                    "Vous devez reprendre les informations suivantes et les communiquer à l’hébergeur responsable de votre domaine. "
                  )
                ) +
                "\n        "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "CustomTable",
        [
          _c("template", { slot: "header" }, [
            _c("th", [
              _c(
                "div",
                { staticClass: "typographies-paragraph-medium-regular" },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$l10n.__("Type")) +
                      "\n                "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("th", [
              _c(
                "div",
                { staticClass: "typographies-paragraph-medium-regular" },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$l10n.__("Nom")) +
                      "\n                "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "col-action" }),
            _vm._v(" "),
            _c("th", [
              _c(
                "div",
                { staticClass: "typographies-paragraph-medium-regular" },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$l10n.__("Valeur")) +
                      "\n                "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "col-action" })
          ]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "content" },
            _vm._l(_vm.dnsData, function(data) {
              return _c("tr", { key: data.id }, [
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "typographies-paragraph-medium-regular" },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(data.type) +
                          "\n                    "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "typographies-paragraph-medium-regular" },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(data.host) +
                          "\n                    "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c(
                      "CompassTooltip",
                      {
                        staticClass: "fright",
                        attrs: { content: _vm.$t.__("common.actions.copy") }
                      },
                      [
                        _c("CompassIconButton", {
                          directives: [
                            {
                              name: "clipboard",
                              rawName: "v-clipboard:copy",
                              value: data.host,
                              expression: "data.host",
                              arg: "copy"
                            },
                            {
                              name: "clipboard",
                              rawName: "v-clipboard:error",
                              value: _vm.onError,
                              expression: "onError",
                              arg: "error"
                            },
                            {
                              name: "clipboard",
                              rawName: "v-clipboard:success",
                              value: _vm.onCopy,
                              expression: "onCopy",
                              arg: "success"
                            }
                          ],
                          attrs: { icon: "duplicate", size: "small" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "typographies-paragraph-medium-regular" },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(data.data) +
                          "\n                    "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c(
                      "CompassTooltip",
                      {
                        staticClass: "fright",
                        attrs: { content: _vm.$t.__("common.actions.copy") }
                      },
                      [
                        _c("CompassIconButton", {
                          directives: [
                            {
                              name: "clipboard",
                              rawName: "v-clipboard:copy",
                              value: data.host,
                              expression: "data.host",
                              arg: "copy"
                            },
                            {
                              name: "clipboard",
                              rawName: "v-clipboard:error",
                              value: _vm.onError,
                              expression: "onError",
                              arg: "error"
                            },
                            {
                              name: "clipboard",
                              rawName: "v-clipboard:success",
                              value: _vm.onCopy,
                              expression: "onCopy",
                              arg: "success"
                            }
                          ],
                          attrs: { icon: "duplicate", size: "small" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            }),
            0
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "typographies-paragraph-medium-regular" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Une fois la configuration communiquée à votre hébergeur, cela peut prendre parfois quelques heures pour l’activation et l’application.\nVous pouvez connaitre le statut de votre domaine dans Réglages > Emails > Paramètres des emails."
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("CompassAlert", {
        staticClass: "mb-0",
        attrs: {
          description: _vm.$t.__(
            "email.EmailOnboardingDomain.no_take_step_emails_may_not_be_received"
          ),
          showClose: false,
          type: "warning"
        }
      }),
      _vm._v(" "),
      _vm._t("actions", [
        _c(
          "div",
          {
            staticClass:
              "flex-level flex-end email-onboarding-domain__container-buttons-submit mt-2"
          },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("email.EmailOnboardingDomain.do_this_later"),
                type: "secondary"
              },
              on: {
                click: function($event) {
                  return _vm.$emit("validDomain", { appliedConf: false })
                }
              }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__(
                  "email.EmailOnboardingDomain.apply_configuration_on_domain"
                )
              },
              on: {
                click: function($event) {
                  return _vm.$emit("validDomain", { appliedConf: true })
                }
              }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }